import { Observable, of, zip } from "rxjs";
import { map } from "rxjs/operators";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";

let _configPropsProp: Record<string, string> = {};

export function setConfigPropsProps(configPropsProp: Record<string, string>) {
  _configPropsProp = configPropsProp;
}

function request(neededConfigPropIds: string[]) {
  return HttpClient.get({
    baseUri:
      ApiEndpointResolver.getConfigPropsUrl() +
      neededConfigPropIds
        .map((configPropId) => `name=${configPropId}`)
        .join("&"),
  });
}

function getConfigPropFromProps(props: string[]) {
  const result: Record<string, string> = {};
  for (let i = 0; i < props.length; i++) {
    result[props[i]] = _configPropsProp[props[i]];
  }

  return of(result);
}

const ConfigPropService = {
  get: (configPropIds: string[]): Observable<Record<string, string>> => {
    return ApiCacheService.withCache_Array(
      "ConfigPropService",
      configPropIds,
      (neededConfigPropIds: string[]) => {
        let propConfigProps = [];
        let requestConfigProps = [];
        for (var i = 0; i < neededConfigPropIds.length; i++) {
          let configProp = neededConfigPropIds[i];
          if (
            _configPropsProp[configProp] !== undefined &&
            _configPropsProp[configProp] !== null
          ) {
            propConfigProps.push(configProp);
          } else {
            requestConfigProps.push(configProp);
          }
        }

        if (propConfigProps.length !== 0 && requestConfigProps.length === 0) {
          return getConfigPropFromProps(propConfigProps);
        }

        if (propConfigProps.length !== 0 && requestConfigProps.length !== 0) {
          return zip(
            getConfigPropFromProps(propConfigProps),
            request(requestConfigProps)
          ).pipe(
            map((x) => {
              const lhs: any = x[0];
              const rhs: any = x[1];

              for (var key in rhs) {
                lhs[key] = rhs[key];
              }

              return lhs;
            })
          );
        }

        return request(requestConfigProps);
      }
    );
  },
  isYesOrTrue: (configProp: string | boolean | number) => {
    return (
      configProp === true ||
      configProp === "Yes" ||
      configProp === "yes" ||
      configProp === 1 ||
      configProp === "True" ||
      configProp === "true"
    );
  },
};

export default ConfigPropService;
